import { Action } from '@ngrx/store';
import { Alarm, File } from '@app/models';

export enum AlarmActionTypes {
  Load = '[API] Load alarms',
  LoadSuccess = '[API] Load alarms success',
  LoadFail = '[API] Load alarms fail',
  AddAll = '[Alarm] Add all',
  AddPicture = '[Alarm] Add picture',
  Create = '[API] Create alarm',
  CreateSuccess = '[API] Create alarm success',
  CreateFail = '[API] Create alarm fail',

  AddOne = '[Alarm] Add one',
  UpdateAlarm = '[API] Update alarm',
  UpdateAlarmSuccess = '[Alarm] Update alarm success',
  UpdateFail = '[Alarm] Update alarm fail',
  UpdateAlarmOne = '[Alarm] Update alarm one',
  DeleteAlarm = '[Alarm] delete alarm',
  DeleteAlarmSuccess = '[Alarm] delete alarm success',
  DeleteAlarmFail = '[Alarm] delete alarm fail'
}

export class Load implements Action {
  readonly type = AlarmActionTypes.Load;
  constructor(public FollowId?: number) {}
}

export class LoadSuccess implements Action {
  readonly type = AlarmActionTypes.LoadSuccess;
  constructor(public alarms: Alarm[]) {}
}

export class LoadFail implements Action {
  readonly type = AlarmActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class AddAll implements Action {
  readonly type = AlarmActionTypes.AddAll;
  constructor(public alarms: Alarm[]) {}
}

export class AddPicture implements Action {
  readonly type = AlarmActionTypes.AddPicture;
  constructor(public file: File) {}
}

export class AddOne implements Action {
  readonly type = AlarmActionTypes.AddOne;
  constructor(public alarm: Alarm) {}
}

export class Create implements Action {
  readonly type = AlarmActionTypes.Create;
  constructor(public alarm: Alarm) {}
}

export class CreateSuccess implements Action {
  readonly type = AlarmActionTypes.CreateSuccess;
  constructor(public alarm: Alarm) {}
}

export class CreateFail implements Action {
  readonly type = AlarmActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class UpdateAlarm implements Action {
  readonly type = AlarmActionTypes.UpdateAlarm;
  constructor(public id: number, public alarm: any) {}
}

export class UpdateFail implements Action {
  readonly type = AlarmActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateAlarmSuccess implements Action {
  readonly type = AlarmActionTypes.UpdateAlarmSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateAlarmOne implements Action {
  readonly type = AlarmActionTypes.UpdateAlarmOne;
  constructor(public hanger: Alarm) {}
}

export class DeleteAlarm implements Action {
  readonly type = AlarmActionTypes.DeleteAlarm
  constructor(public alarmId: number) {}
}

export class DeleteAlarmSuccess implements Action {
  readonly type = AlarmActionTypes.DeleteAlarmSuccess;
  constructor(public data?: any) {}
}

export class DeleteAlarmFail implements Action {
  readonly type = AlarmActionTypes.DeleteAlarmFail;
  constructor(public error: any) {}
}

export type AlarmActionsUnion =
  | Load
  | LoadFail
  | LoadSuccess
  | AddAll
  | AddPicture
  | AddOne
  | Create
  | CreateSuccess
  | CreateFail
  | UpdateAlarm
  | UpdateAlarmSuccess
  | UpdateFail
  | UpdateAlarmOne
  | DeleteAlarm
  | DeleteAlarmSuccess
  | DeleteAlarmFail;
